var map = {
	"./bpc.png": 1008,
	"./bv.png": 157,
	"./c6bank.png": 1009,
	"./cashme.png": 1010,
	"./click-cash.png": 1011,
	"./creditas-new.png": 1012,
	"./creditas-old.png": 1013,
	"./creditas.png": 158,
	"./easycredito.png": 159,
	"./financiatudo.png": 1014,
	"./finanzero-logo-rounded.png": 1015,
	"./finanzero-logo.png": 1016,
	"./geru.png": 160,
	"./jeitto.png": 1017,
	"./omni.png": 274,
	"./santander.png": 1018,
	"./sim.png": 275,
	"./wimo-old.png": 1019,
	"./wimo.png": 273
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 525;